import axios from 'axios';
import notify from '../../../helpers/toast-notifications';


const state = {}
const getters = {}
const mutations = {}
const actions = {
    postNewStudent({ commit }, newStudent) {
        return new Promise(async (resolve, reject) => {
            try {
                let s = '/student'
                let form = new FormData();
                for (let key in newStudent) {
                    if (newStudent[key]) {
                        if( (key == 'school_id') || (key == 'school_name') ) { s = `/${newStudent.school_name}/${newStudent.school_id}/student/temp`}
                        else { form.append(`${key}`, newStudent[key]) }
                    }
                }
                await axios.post(`${s}`, form);
                resolve()
            }
            catch (err) {
                notify(
                    err.message,
                     { timeout: 2000, rtl: true },
                     "error"
                 );
                reject()
            }
        })
    },
}



export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}